var React = require('react');

function Trash (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M2.5 5H17.5","stroke":"#F33F3F","strokeWidth":"1.66667","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M15.8333 5V16.6667C15.8333 17.5 15 18.3333 14.1666 18.3333H5.83329C4.99996 18.3333 4.16663 17.5 4.16663 16.6667V5","stroke":"#F33F3F","strokeWidth":"1.66667","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M6.66663 4.99996V3.33329C6.66663 2.49996 7.49996 1.66663 8.33329 1.66663H11.6666C12.5 1.66663 13.3333 2.49996 13.3333 3.33329V4.99996","stroke":"#F33F3F","strokeWidth":"1.66667","strokeLinecap":"round","strokeLinejoin":"round","key":2})]);
}

Trash.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = Trash;

Trash.default = Trash;
